
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b7083e30&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TrendView.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TrendView.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b7083e30!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TrendView.vue"),
  /* scopeId */
  "data-v-b7083e30",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/views/TrendView.vue
// module id = ./dev/src/views/TrendView.vue
// module chunks = 0